import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import CommonAppointmentCalendar from "./CommonAppointmentCalendar";
import { fetchAppointmentsLeadAction } from "../../../store/actions/AppointmentActions";

const TelecallerAppointmentCalendar = ({
  leadId,
  doctorId,
  patientId,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);

  // ✅ Safe selector
  const { appointments = [] } = useSelector(
    (state) => state.appointmentState || {}
  );

  // ✅ Fetch appointments
  useEffect(() => {
    if (leadId) {
      dispatch(fetchAppointmentsLeadAction(leadId, patientId));
    }
  }, [leadId, patientId, dispatch]);

  // ✅ Check if appointment already exists
  const hasAppointment = appointments.some(
    (a) => String(a.lead_id) === String(leadId)
  );

  return (
    <div>
      {/* Calendar always visible */}
      <CommonAppointmentCalendar
        leadId={leadId}
        patientId={patientId}
        doctorId={doctorId}
        module="telecaller"
        appointmentType="telecaller"
        currentLeadId={leadId}
        selectedDate={selectedDate}
        openFromTelecaller
      />

      {/* Hide booking UI if appointment already exists */}
      {!hasAppointment && (
        <div className="card mb-4 shadow-none mt-2">
          <div className="row align-items-end p-3">
            
            {/* Date Picker */}
            <div className="col-md-4">
              <label className="form-label fw-semibold text-dark mb-3">
                Select Preferred Date:
              </label>

              <div className="position-relative">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  minDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  placeholderText="Choose a date"
                  showPopperArrow={false}
                  popperPlacement="bottom-start"
                  className="form-control form-control-lg ps-5 pe-5"
                />

                {/* Calendar Icon */}
                <i
                  className="fa fa-calendar position-absolute"
                  style={{
                    left: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    fontSize: "18px",
                    color: "#6c757d",
                  }}
                />

                {/* Clear Button */}
                {selectedDate && (
                  <i
                    className="fa fa-times position-absolute"
                    onClick={() => setSelectedDate(null)}
                    style={{
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                      color: "#6c757d",
                      cursor: "pointer",
                      zIndex: 11,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Confirm Button */}
            <div className="col-md-2 d-flex align-items-end">
  <button
    className="btn btn-outline-primary w-100"
    style={{ height: "60px" }}
    onClick={() => {
      if (!selectedDate) {
        alert("Please select a date");
        return;
      }

      window.dispatchEvent(
        new CustomEvent("telecallerBookClick", {
          detail: { selectedDate },
        })
      );
    }}
  >
    Confirm
  </button>
</div>


          </div>
        </div>
      )}
    </div>
  );
};

export default TelecallerAppointmentCalendar;
